module.exports = __webpack_public_path__ + "static/N2N0-a95cc51ceb85af0743d1f87fade30659.jpg";